import { Component, OnInit, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { SwUpdate, SwPush } from '@angular/service-worker';
import { map, merge, takeUntil } from 'rxjs/operators';
import { fromEvent, of, Observable, Subject } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { faCog } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'odl-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

    appversion: string;
    persistence_enabled = false;
    update_available: boolean = false;
    online: boolean = true;
    faConfig = faCog;

    private unsubscribe$ = new Subject<void>();

    constructor(
        private db: AngularFirestore,
        private swUpdate: SwUpdate,
        private swPush: SwPush,
        public afAuth: AngularFireAuth,
        private router: Router,
    ) { }

    ngOnInit() {

        this.appversion = '1.26';

        this.db.persistenceEnabled$.subscribe(result => this.persistence_enabled = result);

        if (this.swUpdate.isEnabled) {
            this.swUpdate.available.subscribe(() => {
                if ( !this.update_available ) {
                    if (confirm('Nuova versione dell\'app disponibile. Ricaricare la pagina ora?') ) {
                        window.location.reload();
                    }
                }
                this.update_available = true;
            });
        }

        this.isOnline()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe( status => {
                if ( status === this.online) {
                    return;
                }
                this.online = status;
            });

    }

    isOnline(): Observable<boolean> {
        return new Observable<boolean>().pipe(
            merge(
                of(navigator.onLine),
                fromEvent( window, 'online').pipe(
                    map( () => true)
                ),
                fromEvent( window, 'offline').pipe(
                    map( () => false)
                ),
            )
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    promptLogout() {
        if ( !confirm('Vuoi disconnetterti ed uscire all\'applicazione?') ) {
            return;
        }
        this.afAuth.auth.signOut().then( () => {
            this.router.navigate(['/login']);
        });
    }

    toggleCache() {
        const currentPersistence = localStorage.getItem('persistence');
        console.log('current persistence', currentPersistence);
        if ( currentPersistence && currentPersistence === 'on') {
            console.log('set to off');
            localStorage.setItem('persistence','off');
        } else {
            console.log('set to on');
            localStorage.setItem('persistence','on');
        }
        window.location.reload();
    }
}
